import * as Models from "@gigalot/data-models";
import { getItemFromServer } from "./get-item-from-server";
import router from "@/router";
import store from "@/store";

type DispatchBatch = Models.DispatchToAbattoirBatch | Models.DispatchToSiteBatch;

export async function diedInTransit(dispatchedAnimal: Models.DispatchedAnimal, dispatchBatch: DispatchBatch) {
  //console.log(dispatchedAnimal);

  let mortality: Models.Mortality;

  if (dispatchedAnimal.mortalityGuid) {
    //Load up mortality page with mortality
    mortality = await getItemFromServer("Mortality", dispatchedAnimal.mortalityGuid);
  } else {
    mortality = Models.factory("Mortality");
    mortality.diedInTransit = true;
    mortality.dispatchBatchGuid = dispatchBatch.guid;
    mortality.dispatchDestinationType = dispatchBatch.typename === "DispatchToAbattoirBatch" ? "abattoir" : "site";
    if (dispatchBatch.dispatchType) {
      mortality.dispatchType = dispatchBatch.dispatchType as any;
    }
    mortality.sgtin = dispatchedAnimal.sgtin;
    //Create mortality and go to view
    //!!! If mortality saves then don't forget to update dispatchedAnimal.mortalityGuid on the server
    mortality.customFeeder = dispatchBatch?.transport[0]?.customFeeder;
  }

  store.commit("updateUserLocationField", { path: "mortality", value: mortality });
  router.push({ name: "mortality" });
}